import React, { useEffect, useState, useContext, useRef } from "react";
import { set, useForm } from 'react-hook-form';
import Select from 'react-select';
import InputMask from 'react-input-mask';
import api from '../../services/api';
import Swal from "sweetalert2";
import * as moment from 'moment'
import TimeSheetDetalhesContext from "../../contexts/TimeSheetDetalhesContext";
import DatePicker, { registerLocale } from 'react-datepicker';

function TableRows({
    rows,
    addRowTable,
    tableRowRemove,
    handleDateChange,
    handleHoraInicial,
    handleHoraFinal,
    handleDesconto,
    handleDescricao,
    getAtividade,
    atividades,
    getPeritos,
    peritos,
    timesheet,
    isFromProjetoInterno = false
}) {
    const multiselectRef = useRef();
    const multiselectPeritoRef = useRef();
    const [startDate, setStartDate] = useState([]);
    // const refArr = useRef([])
    // refArr.current = rows.map((item, index) => {
    //     return refArr.current[index] || React.createRef();
    // });

    console.log('isFromProjetoInterno', isFromProjetoInterno);

    const calcularHoras = (data, index) => {
        var hrInicio = moment(data.horainicio, "HH:mm");
        var hrFinal = moment(data.horafinal, "HH:mm");
        hrFinal.subtract({ 'hours': data.timeDesconto.split(":")[0], 'minutes': data.timeDesconto.split(":")[1] })
        var horas = hrFinal.diff(hrInicio, "minutes");
        data.total = horas > 0 ? horas : 0;
        var hours = Math.trunc(horas / 60);
        var minutes = horas % 60;
        minutes = minutes < 10 ? '0' + minutes : minutes;
        document.getElementById("totalHora" + index).innerHTML = horas > 0 ? hours + ":" + minutes : '00:00';
        return horas;
    };


    const valorTotalAtividade = async (data, index) => {
        data.isloading = true
        var payload = {
            IdTimesheet: timesheet.actions.idTimesheet,
            IdPerito: data.selectedPerito.id,
            DataLancamento: data.dataLancamento
        }
        let defaultValor = 300;
        try {
            const response = await api.post(`TimesheetPrecificacao/precificacao`, payload);
            defaultValor = response.data?.data?.valorHora
        }
        catch { }
        const defaulyValor = defaultValor || 300;
        data.isloading = false
        var hrInicio = moment(data.horainicio, "HH:mm");
        var hrFinal = moment(data.horafinal, "HH:mm");
        hrFinal.subtract({ 'hours': data.timeDesconto.split(":")[0], 'minutes': data.timeDesconto.split(":")[1] })
        var horas = hrFinal.diff(hrInicio, "minutes");
        data.total = horas > 0 ? horas : 0;
        var hours = Math.trunc(horas / 60);
        var minutes = horas % 60;
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var valorTotal = (hours * defaulyValor) + (minutes * (defaulyValor / 60));
        let valorTotalString = valorTotal.toLocaleString('pt-br', { style: 'currency', currency: 'BRL', maximumFractionDigits: 2 });

        if(isFromProjetoInterno)
        {
            document.getElementById("valorTotalAtividade" + index).innerHTML = '';
        }
        else
        {
            document.getElementById("valorTotalAtividade" + index).innerHTML = valorTotal > 0 ? valorTotalString : 'R$ 0,00';
        }
        return valorTotal;
    };

    const uptIntervalo = (data, event, index) => {
        var intervalo = event.target.value;
        handleDesconto(data, intervalo);
        calcularHoras(data, index);
        valorTotalAtividade(data, index);

        addRowTable(data, index);
    };


    const calcularHorasGeral = (data, index) => {
        if (data?.horainicio && data?.horafinal && data.horainicio.length === 5 && data.horafinal.length === 5) {

            data.intervalo = data?.intervalo ?? "00:00";

            handleDesconto(data, data.intervalo);
            calcularHoras(data, index);
            valorTotalAtividade(data, index);
        }
    }


    let atividadesFormatadas = [];
    const formatAtividades = () => {
        atividades.map(atividade => {
            var item = {
                "value": atividade.value,
                "id": atividade.key,
                "label": atividade.value
            };
            atividadesFormatadas.push(item);
        }
        );
    }
    formatAtividades();


    const checkAtividade = (data, atividade, index) => {

        if (data.idAtividade == '' || data.idAtividade == null || data.idAtividade == undefined) {
            Swal.fire({
                title: "Atenção",
                text: "Atividade não informada!",
                icon: "error",
                showConfirmButton: false,
                timer: 2500
            });


            if (rows[rows.length - 1]?.refArr) {
                rows[rows.length - 1].refArr.current.focus();
            }
        }
    };

    const handleDateChangeEv = (rowsData, event, index) => {
        if (!handleDateChange(rowsData, event, index))
            return;

        if (event != null && event != undefined && event != '') {
            startDate[index] = event;
            setStartDate([...startDate]);
        }
    };

    const formatDtLanc = (data) => {

        if (data == null || data == undefined || data == '') {
            return null;
        }

        return new Date(data);
    };


    const addRowTableRow = (rowsData, index) => {
        calcularHorasGeral(rowsData, index);
        addRowTable(rowsData, index);
    }


    return (
        <>
            {
                rows.map((rowsData, index) => {
                    return (
                        <tr key={rowsData.id}>
                            <td style={{ width: '20%', padding: '.2rem' }}>
                                <Select
                                    isClearable={true}
                                    className="basic-single profissional"
                                    classNamePrefix="profissional"
                                    placeholder={'Profissional'}
                                    defaultValue={[rowsData.selectedPerito]}
                                    options={peritos}
                                    onChange={(perito) => {
                                        getPeritos(rowsData, perito)
                                        if (rowsData.dataLancamento != "" &&
                                            rowsData.horainicio != "" &&
                                            rowsData.horafinal != "") {
                                            valorTotalAtividade(rowsData, index)
                                        }
                                    }}
                                    ref={rowsData.refArr}
                                />
                            </td>
                            <td style={{ padding: '.2rem' }} >
                                <DatePicker name='Data' dateFormat="dd/MM/yyyy" className="input-table-lote-list" selected={formatDtLanc(startDate[index])} onChange={(event) => handleDateChangeEv(rowsData, event, index)} onBlur={(event) => handleDateChange(rowsData, event, index)}
                                    customInput={<MaskedInput />}
                                />
                            </td>
                            <td style={{ width: '20%', padding: '.2rem' }}>
                                <div style={{ width: '100%' }} className="position-relative form-group">
                                    <Select
                                        ref={multiselectRef}
                                        isClearable={true}
                                        className="basic-single"
                                        placeholder={'Atividade'}
                                        options={atividadesFormatadas}
                                        onChange={(atividade) => getAtividade(rowsData, atividade, index)}
                                        onBlur={(atividade) => checkAtividade(rowsData, atividade, index)}
                                    />
                                </div>
                            </td>
                            <td style={{ padding: '.2rem' }}>
                                <textarea
                                    type="text"
                                    className="input-form-list"
                                    style={{ width: '100%', minWidth: '100px' }}
                                    name="Descrição"
                                    placeholder="Descrição"
                                    onBlur={(event) => handleDescricao(rowsData, event)}
                                ></textarea>
                            </td>
                            <td style={{ padding: '.2rem' }}>
                                <InputMask
                                    autoComplete="off"
                                    mask="99:99"
                                    type='text'
                                    className="input-table-lote-list"
                                    name='horaInicial'
                                    onBlur={(event) => { handleHoraInicial(rowsData, event, index); calcularHorasGeral(rowsData, index) }}
                                />
                            </td>
                            <td style={{ padding: '.2rem' }}>
                                <InputMask
                                    autoComplete="off"
                                    mask="99:99"
                                    type='text'
                                    className="input-table-lote-list"
                                    name='horaFinal'
                                    onBlur={(event) => { handleHoraFinal(rowsData, event, index); calcularHorasGeral(rowsData, index); }}
                                />
                            </td>
                            <td style={{ width: '80px' }}>
                            <InputMask
                                autoComplete="off"
                                mask="99:99"
                                type='text'
                                className="input-table-lote-list"
                                placeholder='Intervalo'
                                defaultValue="00:00"
                                name='desconto'
                                onBlur={(event) => {
                                    if (event.target.value.trim() === "" || event.target.value === "__:__") {
                                        event.target.value = "00:00"; // Se o campo estiver vazio, atribui 00:00
                                    }
                                    uptIntervalo(rowsData, event, index); // Chama a função normalmente
                                }}
                            />
                            </td>
                            <td style={{ padding: '.2rem' }} className="input-form-list" id={"totalHora" + index}></td>
                            {!isFromProjetoInterno ? <td style={{ padding: '.2rem' }} className="input-form-list" id={"valorTotalAtividade" + index}>
                                <div>
                                    {
                                        rowsData.isloading &&
                                        (<div className="spinner-border ms-auto" style={{ color: "#EE4B21", height: "20px", width: "20px" }} role="status" aria-hidden="true"></div>)
                                    }
                                </div>

                            </td> : <td style={{ padding: '.2rem' }} className="input-form-list" id={"valorTotalAtividade" + index}></td>}
                            <td style={{ padding: '.2rem' }}>
                                {rows.length == (index + 1) && (<span className="addIcon" onClick={() => addRowTableRow(rowsData, index)}>+</span>)}
                                {rows.length > 1 && (<span className="addIcon" onClick={() => tableRowRemove(index)}>-</span>)}
                            </td>
                        </tr>
                    );
                })
            }
        </>
    )
}


const MaskedInput = React.forwardRef(({ value, onChange, onClick }, ref) => (
    <div className="ui input" onClick={onClick}>
        <InputMask className="input-form-list" ref={ref} mask="99/99/9999" value={value} onChange={onChange} />
    </div>
));

export const Table = ({
    atividades,
    peritos,
    location,
    setIsOpen,
    formData,
    showCanceledTimeSheet,
    getTimesheetAtividade,
    getTimesheetGrupoAtividade,
    isFromProjetoInterno
}) => {
    const [rows, initRow] = useState([]);
    var [errorMsg, setErrorMsg] = useState(null);
    const { timesheet } = useContext(TimeSheetDetalhesContext);

    let peritosFormatados = [];
    const formatPeritos = () => {
        peritos.map(atividade => {
            var item = {
                "value": atividade.idUsuario,
                "id": atividade.idUsuario,
                "label": `${atividade.nome}`
            };
            peritosFormatados.push(item);
        });
    }
    formatPeritos()

    useEffect(() => {
        if (rows.length > 0) {
            rows[rows.length - 1].refArr.current.focus()
        }
    }, [rows.length]);


    const compararHorarios = (horainicio1, horafinal1, horainicio2, horafinal2) => {
        const [horaInicio1, minutoInicio1] = horainicio1.split(':').map(Number);
        const [horaFinal1, minutoFinal1] = horafinal1.split(':').map(Number);
        const [horaInicio2, minutoInicio2] = horainicio2.split(':').map(Number);
        const [horaFinal2, minutoFinal2] = horafinal2.split(':').map(Number);

        const totalMinutosInicio1 = horaInicio1 * 60 + minutoInicio1;
        const totalMinutosFinal1 = horaFinal1 * 60 + minutoFinal1;
        const totalMinutosInicio2 = horaInicio2 * 60 + minutoInicio2;
        const totalMinutosFinal2 = horaFinal2 * 60 + minutoFinal2;

        const intervalo1 = [totalMinutosInicio1, totalMinutosFinal1];
        const intervalo2 = [totalMinutosInicio2, totalMinutosFinal2];


        const temIntersecao = intervalo1[0] < intervalo2[1] && intervalo2[0] < intervalo1[1];
        const saoIguais = intervalo1[0] === intervalo2[0] && intervalo1[1] === intervalo2[1];

        return (saoIguais || temIntersecao) ? true : false;
    }


    const compararDatas = (data1, data2) => {
        const timestamp1 = new Date(data1).getTime();
        const timestamp2 = new Date(data2).getTime();

        return timestamp1 === timestamp2;
    }

    const compararArraysProfissionais = (array1, array2) => {
        const stringArray1 = JSON.stringify(array1);
        const stringArray2 = JSON.stringify(array2);

        return (stringArray1 === stringArray2);
    }

    const validarTime = (time) => {
        return moment(time, "HH:mm", true).isValid();
    }

    const validarData = (data) => {
        return moment(data, "YYYY-MM-DD", true).isValid();
    }


    const validarDataMaiorAtual = (data) => {
        return moment(data, "YYYY-MM-DD", true).isAfter(moment(), 'day');
    }

    const isExists = (value) => {
        return value !== null && value !== undefined && value !== '';
    }

    const compararHorarioAtividade = (horainicio, horafinal) => {

        const [horaInicio, minutoInicio] = horainicio.split(':').map(Number);
        const [horaFinal, minutoFinal] = horafinal.split(':').map(Number);

        const totalMinutosInicio = horaInicio * 60 + minutoInicio;
        const totalMinutosFinal = horaFinal * 60 + minutoFinal;

        if (totalMinutosInicio > totalMinutosFinal) {
            Swal.fire({
                title: "Atenção",
                text: "Horário de início maior que o horário final!",
                icon: "error",
                showConfirmButton: false,
                timer: 2500
            });
        }

        return (totalMinutosInicio > totalMinutosFinal);
    }

    const calcularHoras = (data, index) => {

        var hrInicio = moment(data.horainicio, "HH:mm");
        var hrFinal = moment(data.horafinal, "HH:mm");

        if (data.descontarRefeicao) {
            hrFinal.subtract({ 'hours': data.timeDesconto.split(":")[0], 'minutes': data.timeDesconto.split(":")[1] })
        }
        var horas = hrFinal.diff(hrInicio, "minutes");
        data.total = horas > 0 ? horas : 0;
        var hours = Math.trunc(horas / 60);
        var minutes = horas % 60;
        minutes = minutes < 10 ? '0' + minutes : minutes;
        return horas > 0 ? hours + ":" + minutes : '00:00';;
    };



    const verificarTodosInputs = (data, index, returnFocus = false) => {
        try {

            if (
                data.peritos.length < 0
                || data.dataLancamento.length < 10
            ) {
                return;
            }


            for (const row of rows) {

                if (row.dataLancamento != '' && row.dataLancamento != null && row.dataLancamento != undefined) {

                    if (!validarData(row.dataLancamento)) {
                        errorMsg = "Data inválida!";
                        registrationFailure(errorMsg);
                        setErrorMsg(errorMsg);

                        if (returnFocus && rows[rows.length - 1]?.refArr) {
                            rows[rows.length - 1].refArr.current.focus();
                        }

                        return true;
                    }

                    if (row.idAtividade == null || row.idAtividade == '' || row.idAtividade == undefined) {
                        errorMsg = "Atividade não informada!";
                        registrationFailure(errorMsg);
                        setErrorMsg(errorMsg);

                        if (returnFocus && rows[rows.length - 1]?.refArr) {
                            rows[rows.length - 1].refArr.current.focus();
                        }

                        return true;

                    }



                    if (calcularHoras(data, index) == "00:00" || (!validarTime(row.horainicio) || !validarTime(row.horafinal))) {

                        errorMsg = "Os Horários de início e Término são obrigatórios!";
                        registrationFailure(errorMsg);
                        setErrorMsg(errorMsg);

                        if (returnFocus && rows[rows.length - 1]?.refArr) {
                            rows[rows.length - 1].refArr.current.focus();
                        }


                        return true;
                    }


                    if (validarTime(data.horainicio) && validarTime(data.horafinal) && data?.timeDesconto != "00:00"
                        && calcularHoras(data, index) == "00:00") {
                        if (returnFocus && rows[rows.length - 1]?.refArr) {
                            rows[rows.length - 1].refArr.current.focus();
                        }

                        errorMsg = "Intervalo maior ou igual a diferença entre os horários!";
                        registrationFailure(errorMsg);
                        setErrorMsg(errorMsg);

                        return true;
                    }


                    if (compararHorarioAtividade(row.horainicio, row.horafinal)) {

                        if (returnFocus && rows[rows.length - 1]?.refArr) {
                            rows[rows.length - 1].refArr.current.focus();
                        }

                        return true;
                    }


                    if (data.id !== row.id && compararArraysProfissionais(data.peritos, row.peritos)
                        && compararDatas(data.dataLancamento, row.dataLancamento)
                        && compararHorarios(data.horainicio, data.horafinal, row.horainicio, row.horafinal)

                    ) {
                        errorMsg = "Atividade já cadastrada para este dia!";
                        registrationFailure(errorMsg);
                        setErrorMsg(errorMsg);

                        if (returnFocus && rows[rows.length - 1]?.refArr) {
                            rows[rows.length - 1].refArr.current.focus();
                        }


                        return true;
                    }
                }
            }

            return false;


        } catch (e) {
            console.error(e)
        }
    };


    const verificarAtividadesDuplicadas = (data, index, returnFocus = false) => {
        try {

            if (!isExists(data.horafinal) &&
                !isExists(data.horainicio) &&
                data.peritos.length < 0 &&
                data.dataLancamento.length < 10) {
                return false;
            }

            for (const row of rows) {
                if (data.id !== row.id && compararArraysProfissionais(data.peritos, row.peritos)
                    && compararDatas(data.dataLancamento, row.dataLancamento)
                    && compararHorarios(data.horainicio, data.horafinal, row.horainicio, row.horafinal)
                ) {
                    registrationFailure("Atividade já cadastrada para este dia! ");

                    if (returnFocus && rows[rows.length - 1]?.refArr) {
                        rows[rows.length - 1].refArr.current.focus();
                    }

                    return true;
                }
            }

            return false;
        } catch (e) {
            console.error(e)
        }
    };

    const addRowTable = (rowsData, index) => {
        if (verificarTodosInputs(rowsData, index, true)) {
            return
        }

        if (rows.length != (index + 1)) {
            return
        }

        if (rowsData.idAtividade != null &&
            validarTime(rowsData.horafinal) &&
            validarTime(rowsData.horainicio) &&
            rowsData.peritos.length > 0 &&
            rowsData.dataLancamento.length == 10) {
            initRow([...rows, NovaRow()]);
        }
        else {

            registrationFailure("Verifique os dados informados!");

        }
    };

    const tableRowRemove = (index) => {
        let dataRow = [...rows];
        dataRow.splice(index, 1);
        initRow(dataRow);
    };

    const getPeritos = (data, perito) => {
        if (!perito) return

        data.peritos = [perito.id];
        data.selectedPerito = perito;
    };


    const getAtividade = (data, atividade, index) => {
        if (!atividade) return

        data.idAtividade = atividade.id;
    };

    const handleDescricao = (data, event) => {
        data.descricao = event?.target?.value;
    }

    const handleDesconto = (data, valorDesconto) => {
        data.timeDesconto = valorDesconto;
        data.descontarRefeicao = data.timeDesconto != "00:00";
    }

    const handleHoraFinal = (data, event, index) => {
        data.horafinal = event?.target?.value;

        if (!validarTime(data.horafinal)) {
            registrationFailure("Horário de Término obrigatório!");

            if (rows[rows.length - 1]?.refArr) {
                rows[rows.length - 1].refArr.current.focus();
            }

            return;
        }

        verificarAtividadesDuplicadas(data, index, false);

        if (compararHorarioAtividade(data.horainicio, data.horafinal)) {
            if (rows[rows.length - 1]?.refArr) {
                rows[rows.length - 1].refArr.current.focus();
            }
        };
    }

    const handleHoraInicial = (data, event, index) => {
        data.horainicio = event?.target?.value;

        if (!validarTime(data.horainicio)) {
            registrationFailure("Horário de início obrigatório!");

            if (rows[rows.length - 1]?.refArr) {
                rows[rows.length - 1].refArr.current.focus();
            }
            return;
        }

        verificarAtividadesDuplicadas(data, index, false);

        if (compararHorarioAtividade(data.horainicio, data.horafinal)) {
            if (rows[rows.length - 1]?.refArr) {
                rows[rows.length - 1].refArr.current.focus();
            }
        };

    }

    const handleDateChange = (data, event, index) => {

        let dataAtual = event?.target?.value;
        if (dataAtual == null || dataAtual == undefined || dataAtual == '') {

            dataAtual = moment(event).format('DD/MM/YYYY');
        }

        data.dataLancamento = dataAtual?.split('/').reverse().join('-');

        if (!validarData(data.dataLancamento)) {

            if (rows[rows.length - 1]?.refArr) {
                rows[rows.length - 1].refArr.current.focus();
            }

            registrationFailure("Data inválida!");
            return;
        };


        if (validarDataMaiorAtual(data.dataLancamento)) {

            if (rows[rows.length - 1]?.refArr) {
                rows[rows.length - 1].refArr.current.focus();
            }

            registrationFailure("Data não deve ser maior que a data atual!");
            return;
        };


        verificarAtividadesDuplicadas(data, index, false);

        return true;
    }

    const formActivities = async () => {


        let validacaoD = false;
        setErrorMsg(null);

        var timesheetItemAtividadeAddList = rows.map((row, index) => {

            if (validacaoD) {
                return null;
            }

            if (row.peritos.length > 0 && row.dataLancamento.length == 10) {



                if (verificarTodosInputs(row, index)) {
                    validacaoD = true;
                    return null;
                }

                delete row['refArr'];

                return {
                    ...row,
                    idTimesheet: timesheet.actions.idTimesheet
                };
            }
        });

        if (validacaoD) {
            Swal.fire({
                title: "Atenção",
                text: errorMsg != null ? errorMsg : "Verifique os dados informados !",
                icon: "error",
                confirmButtonText: "OK",
            });
            return;
        }

        if (rows.length > 0) {
            try {

                Swal.fire({
                    title: 'Aguarde...',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    showConfirmButton: false,
                    willOpen: () => {
                        Swal.showLoading()
                    },
                });

                timesheetItemAtividadeAddList = timesheetItemAtividadeAddList.filter((item) => item != null);
                const response = await api.post(`Timesheet/list/atividade`, timesheetItemAtividadeAddList);
                registrationSuccess();
                window.location.reload(false);
            } catch (err) {
                Swal.close();
                console.error(err);
                registrationFailure(err.response.data.notification.messageReturn);
            }
        }
    };

    const registrationSuccess = () => {
        Swal.close();
        Swal.fire({
            title: "Sucesso",
            text: "Cadastro realizado com sucesso",
            icon: "success",
            showConfirmButton: false,
            timer: 2500,
        });
    }

    const registrationFailure = (textNotificacao) => {
        Swal.fire({
            title: "Atenção",
            text: textNotificacao != null ? textNotificacao : "Ops, ocorreu um erro ao realizar o cadastro. Tente novamente em instantes.",
            icon: "error",
            confirmButtonText: "OK",
            timer: 2500
        });
    }

    const NovaRow = () => {
        let dadosUsuario = JSON.parse(localStorage.getItem("PROFILE_DATA_SISCOPE"));
        return {
            id: Math.random(),
            dataLancamento: "",
            idAtividade: "",
            descricao: "",
            horainicio: "",
            horafinal: "",
            total: "",
            totalValor: "",
            peritos: [dadosUsuario.idUsuario],
            selectedPerito: { id: dadosUsuario.idUsuario, value: dadosUsuario.idUsuario, label: dadosUsuario.name },
            isloading: false,
            refArr: React.createRef()
        };
    }

    useEffect(() => {
        initRow([...rows, NovaRow()]);
    }, []);




    return (
        <>
            <table className="table table-striped">
                <thead>
                    <tr>
                        <th style={{ minWidth: '200px' }} >Profissional</th>
                        <th style={{ width: '50px' }}>Data</th>
                        <th>Atividade</th>
                        <th style={{ width: '100%', minWidth: '200px' }} >Descrição</th>
                        <th style={{ width: '54px' }}>Início</th>
                        <th style={{ width: '54px' }}>Término</th>
                        <th style={{ width: '54px' }}>Intervalo</th>
                        <th>Total Horas</th>
                        {!isFromProjetoInterno ? <th>Total Valor</th> : ''}
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <TableRows
                        rows={rows}
                        tableRowRemove={tableRowRemove}
                        addRowTable={addRowTable}
                        handleDateChange={handleDateChange}
                        handleHoraInicial={handleHoraInicial}
                        handleHoraFinal={handleHoraFinal}
                        handleDesconto={handleDesconto}
                        handleDescricao={handleDescricao}
                        getAtividade={getAtividade}
                        atividades={atividades}
                        peritos={peritosFormatados}
                        getPeritos={getPeritos}
                        timesheet={timesheet}
                        isFromProjetoInterno={isFromProjetoInterno}
                    />
                </tbody>
            </table>
            <div className="position-relative form-group modal-align-center">
                <input className='default-button-red' value='Salvar' type="button" onClick={formActivities} />
            </div>
        </>
    );
};